import { shallowRef } from 'vue'
import { TBlock, type TBlockReference } from '~/types/block-types'
import { getBlock } from '~/services/custom-endpoints'
import { useAllBlock } from '~/composables/useAllBlocks'
import ErrorBlock from '~/components/blocks/ErrorBlock.vue'

export const useBlockData = async (reference: TBlockReference): Promise<any> => {
  const blocks = useAllBlock()
  const blockDefinition = blocks.value[reference.collection]

  const fields = (blockDefinition) ? blockDefinition.fields : undefined

  if (fields) {
    const { data, error } = await getBlock(reference.collection, reference.item, blockDefinition.fields)

    if (error.value) {
      console.warn(error.value?.message)
    }

    return {
      blockData: data.value?.data as TBlock,
      additionalProps: blockDefinition.additionalProps || {},
      component: blockDefinition.component
        ? shallowRef(blockDefinition.component)
        : shallowRef(ErrorBlock)
    }
  }

  return {
    blockData: undefined,
    additionalProps: {},
    component: shallowRef(ErrorBlock)
  }
}
